import { fetchTopDestinations as fetchTopDestinationsFromApi } from '@/api/proxy'
import { objectHasKeys, isNull } from '@/utils/comparators'
import { thirtyDaysPolicyHasExpired } from '@/utils/cachePolicies'

/**
* Forces an API fetch of top calling destinations based on geolocation.
* * @param {object} topDestinationsRequest
*/
const fetchTopDestinations = async ({ commit }, topDestinationsRequest) => {
  commit('SET_GEOLOCATION', topDestinationsRequest.geolocation)
  let response = await fetchTopDestinationsFromApi(topDestinationsRequest)
  commit('SET_TOP_DESTINATIONS', response)
}

/**
* Load top calling destinations based on geolocation.
* Get data from local storage or fetch from API if stale or different geolocation.
* Data is cached for 30 days in local storage.
* @param {object} topDestinationsRequest
*/
const loadTopDestinations = async ({ dispatch, state }, topDestinationsRequest) => {
  let isStale = thirtyDaysPolicyHasExpired(state.created) || !objectHasKeys(state.topDestinations)
  let isDifferentGelocation = isNull(state.geolocation) || state.geolocation !== topDestinationsRequest.geolocation
  if (isStale || isDifferentGelocation) {
    await dispatch('fetchTopDestinations', topDestinationsRequest)
  }
}

export default {
  fetchTopDestinations,
  loadTopDestinations
}



// WEBPACK FOOTER //
// ./src/store/modules/communication/countries/actions.js